/**
 * Search component.
 * @module components/theme/Search/Search
 */
import Search from '@package/components/Search';

export default Search;
